<template>
	<div data-tour-scope="shipping-methods">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title> {{ $vuetify.lang.t('$vuetify.front.ecommerce.shipmentmethod') }}</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>

							<v-spacer></v-spacer>
							<v-toolbar-items shift>
								<!-- una sola azione possibile: il piu' porta dritto alla pagina, senza menu -->
								<v-btn elevation="0" text title="Aggiungi metodo di spedizione" data-tour="add" @click="createItem">
									<v-icon>mdi-plus</v-icon>
								</v-btn>
							</v-toolbar-items>
						</v-toolbar>


						<v-data-table
							:headers="headers"
							:items="getItems"
							:options.sync="settings.options"
							:server-items-length="total"
							must-sort
							class="elevation-0"
							:footer-props="{ 'items-per-page-options': listSize }"
							item-key="_id"
							data-tour="table"
							:hide-default-header="mobileCards"
							:class="{ 'table-cards': mobileCards }"
						>
							<template v-slot:body="{ items }">
								<!-- telefono: ogni riga diventa una card chiave/valore -->
								<tbody v-if="mobileCards" class="shipmethod-cards">
									<tr v-for="item in items" :key="item._id">
										<td :colspan="headers.length" class="px-3 py-1">
											<key-value-card :title="item.trans ? item.trans.name : ''" :fields="campiCard(item)">
												<template v-slot:actions>
													<v-menu top eager>
														<template v-slot:activator="{ on, attrs }">
															<v-btn icon small color="primary" v-bind="attrs" v-on="on" data-tour="row-menu" @click.stop>
																<v-icon>mdi-dots-vertical</v-icon>
															</v-btn>
														</template>
														<v-list>
															<v-list-item link data-tour="row-edit" @click="editItem(item)">
																<v-list-item-title class="size9">Modifica</v-list-item-title>
															</v-list-item>
															<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
																<v-list-item-title class="size9">Elimina</v-list-item-title>
															</v-list-item>
														</v-list>
													</v-menu>
												</template>
												<div class="d-flex align-center justify-space-between" data-tour="switch">
													<span class="card-label">Attivo</span>
													<v-switch v-model="item.active" @change="changeStatus(item)" color="primary" class="mt-0 pt-0" hide-details></v-switch>
												</div>
											</key-value-card>
										</td>
									</tr>
								</tbody>
								<tbody v-else>
									<tr v-for="item in items" :key="item._id">
										<td class="pl-0 pr-0 ml-0 mr-0" style="width: 5px">
											<v-menu top eager>
												<template v-slot:activator="{ on, attrs }">
													<v-btn icon dark v-bind="attrs" v-on="on" color="primary" dense data-tour="row-menu">
														<v-icon dark> mdi-dots-vertical </v-icon>
													</v-btn>
												</template>
												<v-list>
													<v-list-item link data-tour="row-edit" @click="editItem(item)">
														<v-list-item-title class="size9">Modifica</v-list-item-title>
													</v-list-item>
													<v-list-item link data-tour="row-delete" @click="deleteItem(item)">
														<v-list-item-title class="size9">Elimina</v-list-item-title>
													</v-list-item>
												</v-list>
											</v-menu>
										</td>
										<td data-tour="switch">
											<v-switch v-model="item.active" @change="changeStatus(item)" color="primary" class="mt-0" hide-details></v-switch>
										</td>

										<td class="text-left">{{ item.created_at | moment('DD/MM/YYYY') }}</td>
										<td class="text-left">{{ item.trans ? item.trans.name : '' }}</td>
									</tr>
								</tbody>
							</template>
						</v-data-table>
					</v-card>
					<v-snackbar v-model="snackbar.snackbar" :color="snackbar.color" multi-line :timeout="snackbar.timeout">
						{{ snackbar.text }}
						<v-btn dark text @click="snackbar.snackbar = false"> Chiudi </v-btn>
					</v-snackbar>
				</v-layout>
			</v-container>
		</v-main>

		<v-dialog v-model="dialogconfirm" max-width="290">
			<v-card>
				<v-card-title class="headline">Sei sicuro?</v-card-title>
				<v-card-text>Eliminando il metodo di spedizione non potrai più ripristinarlo: alla cassa non comparirà più.</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>

					<v-btn color="primary" text @click="dialogconfirm = false"> Annulla </v-btn>

					<v-btn color="error" text @click="confirmDelete"> Elimina </v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<!-- Ultimo elemento: il nodo viene spostato in `[data-app]` al montaggio. -->
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import { createShippingMethodsTourSteps, stopShippingMethodsTour } from './shipping-methods-tour';
import KeyValueCard from '@/components/core/KeyValueCard.vue';
import { listRouteState } from '@/components/core/list/listRouteState';

const LIST_SIZE = [15, 25, 50, 100];

export default {
	name: 'ShippingMethods',
	// pagina, righe e ordinamento stanno nell'URL: refresh e ritorno dalle schede ripartono da li'
	mixins: [listRouteState({ perPageOptions: LIST_SIZE })],
	setup() {
		return { tour: useTour(createShippingMethodsTourSteps(), { onStop: stopShippingMethodsTour }) };
	},
	components: {
		TourOverlay,
		KeyValueCard,
	},
	data() {
		return {
			snackbar: { snackbar: false, color: '', timeout: 5000, text: '' },
			settings: this.listSettingsFromRoute({
				search: '',
				filters: {},
				options: { sortBy: ['created_at'], sortDesc: [false], page: 1, itemsPerPage: 15 },
			}),
			listSize: LIST_SIZE,
			total: 0,
			headers: [
				// colonna del menu a tre puntini: non si ordina
				{ text: '', value: '', sortable: false },
				{ text: 'Status', value: 'active' },
				{ text: 'Created', value: 'created_at' },
				{ text: 'Metodo di spedizione', value: 'trans.name' },
			],
			dialogconfirm: false,
			daEliminare: null,
		};
	},
	created() {
		this.listLoad();
	},
	computed: {
		// sotto i 769px le righe diventano card
		mobileCards() {
			return this.$vuetify.breakpoint.width < 769;
		},
		...mapGetters({
			getItems: 'shippingmethods/getItems',
		}),
	},
	methods: {
		...mapMutations({
			setPreload: 'settings/setPreload',
		}),
		...mapActions({
			fetchItems: 'shippingmethods/asyncFetchData',
			destroyData: 'shippingmethods/destroyData',
			updateStatus: 'shippingmethods/updateStatus',
			deleteMethod: 'shippingmethods/delete',
		}),
		// coppie chiave/valore della card su telefono
		campiCard(item) {
			return [{ label: 'Creato', value: item.created_at ? this.$moment(item.created_at).format('DD/MM/YYYY') : '' }];
		},
		notifica(color, text) {
			this.snackbar = { snackbar: true, color, timeout: 5000, text };
		},
		changeStatus(item) {
			this.setPreload(true);
			this.updateStatus({ _id: item._id, active: item.active })
				.then(result => {
					if (result && result.data && result.data.data) this.notifica('success', 'Update successfully');
				})
				.catch(err => console.log(err))
				.finally(() => this.setPreload(false));
		},
		// inserimento e modifica sono pagine: la lista resta nel suo URL e ci si torna uguale
		editItem(item) {
			this.$router.push(`/ecommerce/shipmentmethod/${item._id}`);
		},
		createItem() {
			this.$router.push('/ecommerce/shipmentmethod/new');
		},
		getDataFromApi() {
			this.setPreload(true);
			return this.fetchItems(this.settings)
				.then(result => {
					this.total = result ? result.total : 0;
				})
				.catch(err => console.log(err))
				.finally(() => this.setPreload(false));
		},
		deleteItem(item) {
			this.daEliminare = item;
			this.dialogconfirm = true;
		},
		confirmDelete() {
			this.dialogconfirm = false;
			if (!this.daEliminare) return;
			this.setPreload(true);
			this.deleteMethod(this.daEliminare)
				.then(() => this.getDataFromApi())
				.then(() => this.notifica('success', 'Operazione effettuata con successo'))
				.catch(error => console.log(error))
				.finally(() => {
					this.daEliminare = null;
					this.setPreload(false);
				});
		},
	},
	beforeDestroy() {
		this.tour.stop();
		this.destroyData();
	},
};
</script>


<style scoped>
/* vista card: niente layout a colonne, ogni riga e' un blocco e la card prende il 100% */
.table-cards ::v-deep table {
	display: block;
	width: 100%;
}
.shipmethod-cards,
.shipmethod-cards tr {
	display: block;
	width: 100%;
}
.shipmethod-cards tr,
.shipmethod-cards tr:hover {
	background: transparent !important;
}
.shipmethod-cards td {
	display: block;
	width: 100%;
	border-bottom: none !important;
	height: auto !important;
}
/* respiro tra le card e il bordo della card che contiene la tabella */
.shipmethod-cards tr:first-child td {
	padding-top: 12px !important;
}
.shipmethod-cards tr:last-child td {
	padding-bottom: 12px !important;
}
.shipmethod-cards tr + tr td {
	padding-top: 8px !important;
}
.card-label {
	font-size: 14px;
	color: rgba(0, 0, 0, 0.6);
}
/* card in lista fuori da v-data-table */
.kv-list > .kv-card + .kv-card {
	margin-top: 8px;
}
</style>
